import classNames from "classnames";

import { getAPI } from "common/components/utils/getApi";
import { useSelector, shallowEqual } from "react-redux";

export function AppVersionRedux(props) {
    const { environment, version } = useSelector((state) => ({
        environment: state.config.env,
        version: state.config.version
    }), shallowEqual);
    
    return (
        <div className={classNames(props.className)}>
            <div>UI: {environment} ({version})</div>
            <div>API: {getAPI(true)}</div>
        </div>
    );
}
